export var COLORS;
(function (COLORS) {
    COLORS[COLORS["#FFC09F"] = 0] = "#FFC09F";
    COLORS[COLORS["#FFEE93"] = 1] = "#FFEE93";
    COLORS[COLORS["#FCF5C7"] = 2] = "#FCF5C7";
    COLORS[COLORS["#A0CED9"] = 3] = "#A0CED9";
    COLORS[COLORS["#ADF7B6"] = 4] = "#ADF7B6";
})(COLORS || (COLORS = {}));
export var PRIORITY;
(function (PRIORITY) {
    PRIORITY[PRIORITY["LOW"] = 0] = "LOW";
    PRIORITY[PRIORITY["NORMAL"] = 1] = "NORMAL";
    PRIORITY[PRIORITY["HIGH"] = 2] = "HIGH";
    PRIORITY[PRIORITY["CRITICAL"] = 3] = "CRITICAL";
})(PRIORITY || (PRIORITY = {}));
export var THEME;
(function (THEME) {
    THEME["GREEN"] = "green";
    THEME["BLUEGREEN"] = "bluegreen";
    THEME["AMBER"] = "amber";
    THEME["WHITE"] = "white";
})(THEME || (THEME = {}));
export const THEME_LABELS = {
    green: "P1 (green)",
    bluegreen: "P2 (blue-green)",
    amber: "P3 (amber)",
    white: "P4 (white)",
};
export const PRIORITY_DETAILS = [
    {
        label: "Low",
        color: "#0086c1",
        display: "Zz<span>z</span>",
    },
    { label: "Normal", color: "#40B36A", display: "" },
    { label: "High", color: "#F5B725", display: "!" },
    { label: "Critical", color: "#FF6361", display: "!!!" },
];
